// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-module--logo--RSQ2K","link":"logo-module--link--3WCak","rotate":"logo-module--rotate--1R9zs"};